import { toast } from 'react-toastify';

const toastError = (err, t) => {
  const errorMsg = err?.response?.data?.message || err?.response?.data?.error;

  const translate = (key, fallback) => {
    if (t && typeof t === 'function') {
      const translated = t(key);
      return translated !== key ? translated : fallback;
    }
    return fallback;
  };

  if (errorMsg) {
    const translatedMsgKey = `backendErrors.${errorMsg}`;
    const translatedMsg = translate(translatedMsgKey, errorMsg);

    toast.error(translatedMsg, {
      toastId: errorMsg,
    });
  } else if (err?.message) {
    toast.error(err.message, {
      toastId: err.message,
    });
  } else {
    const fallbackMsg = translate('backendErrors.genericError', 'An unexpected error occurred!');

    toast.error(fallbackMsg, {
      toastId: 'genericError',
    });
  }
};

export default toastError;